// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let settings = {};
let node = {};
let fonts = {};
let design = {};

let edgeId = 0;
let currentSelectedNodeId = -1;
let currentAttachedEdgesToUpdatePositions = [];

let oldMaxVisibilityLevel = 1;
const minLevelMatchesNodes = {};
const maxLevelMatchesNodes = {};

const allCurrentDomEdges = {};

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Edge {

    constructor() {}

    init(globalStore, globalSettings, globalNode, globalFonts, globalDesign) {
        log('edge init');

        // global objects
        store = globalStore;
        settings = globalSettings;
        node = globalNode;
        fonts = globalFonts;
        design = globalDesign;

        // needed edge stuff
        setEventListener();
    }

    add(fromNodeId, toNodeId) {
        add(fromNodeId, toNodeId);
    }

    remove(getSelectedElement, getElementId) {
        remove(getSelectedElement, getElementId);
    }

    removeClassSelected() {
        removeClassSelected();
    }

    removeAllConnectedEdgesFromSelectedNode(removedNodeId) {
        removeAllConnectedEdgesFromSelectedNode(removedNodeId);
    }

    prepareAttachedEdgesToUpdatePositions(currentNode) {
        prepareAttachedEdgesToUpdatePositions(currentNode);
    }

    updateAttachedEdgesPositionsFromNode() {
        updateAttachedEdgesPositionsFromNode();
    }

    updateAttachedEdgesVisibilityFromNode() {
        updateAttachedEdgesVisibilityFromNode();
    }

    addClassDragging() {
        addClassDragging();
    }

    removeClassDragging() {
        removeClassDragging();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------

// EVENTLISTENER
// ---------------------------------------------------------------
function setEventListener() {
    const app = $('app');

    app.on('mousedown touchstart', 'edge', (event) => {
        event.stopPropagation();
        const currentEdge = $(event.currentTarget);
        if (currentEdge.hasClass('edited')) return;

        node.removeClassSelected();
        removeClassSelected();

        currentEdge.addClass('selected');
    });

    app.on('mouseup touchend', 'edge', (event) => {
        event.stopPropagation();
        const currentEdge = $(event.currentTarget);
        if (currentEdge.hasClass('edited')) return;

        settings.show();
        $(document).trigger('edgeClickedEvent', [currentEdge]);
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateEdgeDataEvent', (event, currentEdgeId) => {
        // Update DOM
        const currentEdge = $('edge[data-id=' + currentEdgeId + ']');
        const currentElement = $('.selected');
        // check if edge was deleted
        if(!currentEdgeId) return;
        if (parseInt(currentEdgeId) === parseInt(currentElement.data('id'))){
            updateEdgeDataToDom(currentEdge, currentEdgeId, 'regular');
        } else {
            updateEdgeDataToDom(currentEdge, currentEdgeId, 'init');
        }
        

        // Check whether visibility levels match connected nodes
        const edge = store.get().edges[currentEdgeId];
        const fromNodeId = edge.node.fromId;
        const toNodeId = edge.node.toId;
        if (fromNodeId !== undefined && toNodeId !== undefined) {
            const [nodesMinLevel, nodesMaxLevel] = calculateEdgeVisibility(currentEdgeId, fromNodeId, toNodeId);
            minLevelMatchesNodes[currentEdgeId] = edge.visibility.minLevel === nodesMinLevel;
            maxLevelMatchesNodes[currentEdgeId] = edge.visibility.maxLevel === nodesMaxLevel;
        }
    });
    
    $(document).on('edgeDataSync', (event, diff) => {
        // diff -> {id : value}
        const edgeId = Object.keys(diff)[0];
        updateEdgeToStore(edgeId, diff[edgeId]);
        $(document).trigger('updateEdgeDataEvent', [edgeId]);
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateMapDataEvent', () => {
        updateAllEdgesMaxVisibilityLevel();
        updateAllEdgesVisibilityLevel();
    });

    // triggered from modules/xhr/xhr.js
    $(document).on('initMapDataEvent', () => {
        oldMaxVisibilityLevel = store.get().map.visibilityLevels;
        drawInitEdges();
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateMapFontsEdgeContentEvent', () => {
        // update all edges to dom and to store
        updateAllEdgesFont();
    });
}

// INIT EDGES
// ---------------------------------------------------------------
function drawInitEdges() {
    let edgeLength = 0;
    let angle = 0;
    let translateX = 0;
    let translateY = 0;
    let fromNodeId = 0;

    Object.keys(store.get().edges).forEach((id) => {
        edgeLength = store.get().edges[id].measurement.edgeLength;
        angle = store.get().edges[id].measurement.angle;
        translateX = store.get().edges[id].position.x;
        translateY = store.get().edges[id].position.y;
        fromNodeId = store.get().edges[id].node.fromId;

        // add all edges to dom
        addEdgeToDom(id, edgeLength, translateX, translateY, angle, fromNodeId);

        // select new added edge and update styles
        const currentEdge = $('edge[data-id=' + id + ']');
        updateEdgeDataToDom(currentEdge, id, 'init');

        // set edgeId to last max edge id
        if(id >= edgeId) {
            edgeId = parseInt(id) + 1;
        }
    });
}

// ADD EDGE
// ---------------------------------------------------------------
function add(fromNodeId, toNodeId) {
    const newEdgeId = edgeId++;
    const data = calculateEdgePosition(fromNodeId, toNodeId);
    addEdgeToStore(newEdgeId, fromNodeId, toNodeId, data.nodeFromCenterX, data.nodeFromCenterY, data.nodeToCenterX, data.nodeToCenterY, data.radianMeasure, data.edgeLength, data.translateX, data.translateY, data.angle);
    addEdgeToDom(newEdgeId, data.edgeLength, data.translateX, data.translateY, data.angle, fromNodeId, toNodeId);
    minLevelMatchesNodes[newEdgeId] = true;
    maxLevelMatchesNodes[newEdgeId] = true;
}

function addEdgeToDom(newEdgeId, edgeLength, translateX, translateY, angle, fromNodeId, toNodeId) {
    const [minLevel, maxLevel] = calculateEdgeVisibility(newEdgeId, fromNodeId, toNodeId);
    const fontFamily = design.forEdge(newEdgeId, 'fontFamily');

    // hide-on-level-X
    let hideEdgeList = '';
    for (let i = 1; i < minLevel; i++) {
        hideEdgeList += 'hide-on-level-' + i + ' ';
    }
    for (let i = maxLevel + 1; i <= store.get().map.visibilityLevels; i++) {
        hideEdgeList += 'hide-on-level-' + i + ' ';
    }

    let newEdge = $('<edge data-id="' + newEdgeId + '" style="width: ' + edgeLength + 'px; transform: translate(' + translateX +'px, ' + translateY + 'px) rotate(' + angle + 'deg); font-family: ' + fontFamily + ';" class="' + hideEdgeList + '"><span class="start"></span><span class="middle"></span><span class="end"></span></edge>');
    const appendedEdge = $('map').append(newEdge);

    updateEdgeDataToDom(newEdge, newEdgeId, 'init');

    // dom object list of all current edges
    const lastAppendedEdge = appendedEdge.children('edge:last-child');
    allCurrentDomEdges[newEdgeId] = lastAppendedEdge;
}

function addEdgeToStore(edgeId, fromNodeId, toNodeId, nodeFromCenterX, nodeFromCenterY, nodeToCenterX, nodeToCenterY, radianMeasure, edgeLength, translateX, translateY, angle) {
    const [minLevel, maxLevel] = calculateEdgeVisibility(edgeId, fromNodeId, toNodeId);

    store.get().edges.set({
        [edgeId]: {
            node: {
                fromId: parseInt(fromNodeId),
                toId: parseInt(toNodeId)
            },
            measurement: {
                edgeLength: edgeLength,
                radianMeasure: radianMeasure,
                angle: angle
            },
            position: {
                x: translateX,
                y: translateY,
                node: {
                    fromCenterX: nodeFromCenterX,
                    fromCenterY: nodeFromCenterY,
                    toCenterX: nodeToCenterX,
                    toCenterY: nodeToCenterY
                }
            },
            visibility: {
                minLevel: minLevel,
                maxLevel: maxLevel
            },
            design: {
                fontFamily: null,
                fontSize: null,
                fontColor: null,
                borderStyle: null,
                borderWidth: null,
                borderColor: null,
                objectTemplate: '0',
            },
            content: {
                start: '',
                middle: '',
                end: ''
            }
        }
    });

    // update map level control
    $(document).trigger('updateMapLevelControlEvent', ['edge-added', edgeId]);

    log('--- edge.js ---');
    log('add new edge to store');
    log(store.get());
    log('---------------');
}

// UPDATE EDGE
// ---------------------------------------------------------------
function prepareAttachedEdgesToUpdatePositions(currentNode) {
    currentSelectedNodeId = parseInt(currentNode.data('id'));

    // clear current attached edges
    currentAttachedEdgesToUpdatePositions = [];

    let preparedData = {};
    Object.keys(store.get().edges).forEach((id) => {

        if(store.get().edges[id].node.fromId === currentSelectedNodeId || store.get().edges[id].node.toId === currentSelectedNodeId) {

            // sort fromId and toIds --> fromId must be always the current current moved node
            if(store.get().edges[id].node.fromId === currentSelectedNodeId) {
                preparedData.fromNodeId = store.get().edges[id].node.fromId;
                preparedData.toNodeId = store.get().edges[id].node.toId;
            } else {
                preparedData.fromNodeId = store.get().edges[id].node.toId;
                preparedData.toNodeId = store.get().edges[id].node.fromId;
            }

            preparedData.updateEdgeId = id;
            preparedData.edge = $('edge[data-id=' + id + ']');

            currentAttachedEdgesToUpdatePositions.push(preparedData);
            preparedData = {};
        }
    });
}

function updateAttachedEdgesPositionsFromNode() {
    // update all attached edges
    $.each(currentAttachedEdgesToUpdatePositions, (key, value) => {
        updateAttachedEdgePositions(value.fromNodeId, value.toNodeId, value.updateEdgeId, value.edge);
    });
}

function updateAttachedEdgePositions(fromNodeId, toNodeId, updateEdgeId, edge) {
    const data = calculateEdgePosition(fromNodeId, toNodeId);
    updateEdgePositionToDom(edge, data.edgeLength, data.translateX, data.translateY, data.angle);
    updateEdgePositionToStore(updateEdgeId, fromNodeId, toNodeId, data.nodeFromCenterX, data.nodeFromCenterY, data.nodeToCenterX, data.nodeToCenterY, data.radianMeasure, data.edgeLength, data.translateX, data.translateY, data.angle);
}

function updateEdgePositionToDom(edge, edgeLength, translateX, translateY, angle) {
    edge.css({
        'transform': 'translate(' + translateX +'px, ' + translateY + 'px) rotate(' + angle + 'deg)',
        'width': edgeLength + 'px'
    });
}

function updateEdgeToStore(edgeId, edgeUpdated) {
    store.get().edges.set({
        [edgeId]: edgeUpdated
    })
}

function updateEdgePositionToStore(edgeId, fromNodeId, toNodeId, nodeFromCenterX, nodeFromCenterY, nodeToCenterX, nodeToCenterY, radianMeasure, edgeLength, translateX, translateY, angle) {
    store.get().edges[edgeId].set({
        node: {
            fromId: fromNodeId,
            toId: toNodeId
        },
        measurement: {
            edgeLength: edgeLength,
            radianMeasure: radianMeasure,
            angle: angle
        },
        position: {
            x: translateX,
            y: translateY,
            node: {
                fromCenterX: nodeFromCenterX,
                fromCenterY: nodeFromCenterY,
                toCenterX: nodeToCenterX,
                toCenterY: nodeToCenterY
            }
        }
    });

    log('--- edge.js ---');
    log('update edge position to store');
    log(store.get());
    log('---------------');
}

function updateAttachedEdgesVisibilityFromNode() {
    // update all attached edges
    $.each(currentAttachedEdgesToUpdatePositions, (key, value) => {
        updateAttachedEdgeVisibility(value.fromNodeId, value.toNodeId, value.updateEdgeId, value.edge);
    });
}

function updateAttachedEdgeVisibility(fromNodeId, toNodeId, updateEdgeId, edge) {
    const [nodesMinLevel, nodesMaxLevel] = calculateEdgeVisibility(updateEdgeId, fromNodeId, toNodeId);
    updateEdgeVisibilityToStore(updateEdgeId, nodesMinLevel, nodesMaxLevel);
    updateEdgeVisibilityToDom(edge, updateEdgeId);
}

function updateEdgeVisibilityToDom(edge, updateEdgeId) {
    // hide-on-level-X
    const hideEdgeList = getHideEdgeList(updateEdgeId);
    edge.removeClass().addClass(hideEdgeList);
}

function updateEdgeVisibilityToStore(edgeId, nodesMinLevel, nodesMaxLevel) {
    const edge = store.get().edges[edgeId];
    const minLevel = minLevelMatchesNodes[edgeId] ? nodesMinLevel: Math.max(nodesMinLevel, edge.visibility.minLevel);
    const maxLevel = maxLevelMatchesNodes[edgeId] ? nodesMaxLevel: Math.min(nodesMaxLevel, edge.visibility.maxLevel);

    store.get().edges[edgeId].set({
        visibility: {
            minLevel: minLevel,
            maxLevel: maxLevel
        }
    });

    log('--- edge.js ---');
    log('update edge visibility to store');
    log(store.get());
    log('---------------');
}

function updateEdgeDataToDom(currentEdge, currentEdgeId, type = 'regular') { // type = init or regular
    // update content
    currentEdge.find('.start').html(store.get().edges[currentEdgeId].content.start);
    currentEdge.find('.middle').html(store.get().edges[currentEdgeId].content.middle);
    currentEdge.find('.end').html(store.get().edges[currentEdgeId].content.end);

    // update styles
    currentEdge.css({
        'font-family': design.forEdge(currentEdgeId, 'fontFamily'),
        'font-size': design.forEdge(currentEdgeId, 'fontSize') + 'px',
        'color': design.forEdge(currentEdgeId, 'fontColor'),
        'border-top-style': design.forEdge(currentEdgeId, 'borderStyle'),
        'border-top-width': design.forEdge(currentEdgeId, 'borderWidth') + 'px',
        'border-top-color': design.forEdge(currentEdgeId, 'borderColor')
    });

    // hide-on-level-X
    const hideEdgeList = getHideEdgeList(currentEdgeId);

    // regular editor use
    if(type === 'regular') {
        currentEdge.removeClass().addClass('selected ' + hideEdgeList);

    // initial edge load
    } else if(type === 'init') {
        currentEdge.removeClass().addClass(hideEdgeList);

    }
}

function updateAllEdgesFont() {
    $.each(allCurrentDomEdges, (edgeId) => {
        updateEdgeFontToDom(allCurrentDomEdges[edgeId]);
        updateEdgeFontToStore(edgeId);
    });
}

function updateEdgeFontToDom(edge) {
    edge.css({
        'font-family': store.get().map.fonts.edgeContent
    });
}

function updateEdgeFontToStore(edgeId) {
    store.get().edges[edgeId].design.set({
        fontFamily: store.get().map.fonts.edgeContent
    });
}

// REMOVE EDGE
// ---------------------------------------------------------------
function remove(getSelectedElement, getElementId) {
    // hide settings
    settings.hide();

    removeEdgeFromDom(getSelectedElement);
    removeEdgeFromStore(getElementId);
    // TODO was the cause of bug so it's commented for now
    delete minLevelMatchesNodes[getElementId];
    delete maxLevelMatchesNodes[getElementId];
}

function removeEdgeFromDom(getSelectedElement) {
    getSelectedElement.remove();

    const removedEdgeId = getSelectedElement.data('id');
    delete allCurrentDomEdges[removedEdgeId];
}

function removeEdgeFromStore(getElementId) {
    store.get().edges.remove('' + getElementId);

    // update map level control
    $(document).trigger('updateMapLevelControlEvent', ['edge-removed', getElementId]);

    log('--- edge.js ---');
    log('removed edge from store');
    log(store.get());
    log('---------------');
}

function removeAllConnectedEdgesFromSelectedNode(removedNodeId) {
    removedNodeId = parseInt(removedNodeId);
    let fromNodeId = 0;
    let toNodeId = 0;
    let connectedEdge = {};

    Object.keys(store.get().edges).forEach((id) => {
        fromNodeId = store.get().edges[id].node.fromId;
        toNodeId = store.get().edges[id].node.toId;

        if(fromNodeId === removedNodeId || toNodeId === removedNodeId) {
            connectedEdge = $('edge[data-id=' + id + ']');
            removeEdgeFromDom(connectedEdge);
            removeEdgeFromStore(id);
        }
    });
}

// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function calculateEdgePosition(fromNodeId, toNodeId) {
    const nodeFromData = store.get().nodes[fromNodeId];
    const nodeFromBorderWidth = parseFloat(design.forNode(fromNodeId, 'borderWidth'));
    const nodeToData = store.get().nodes[toNodeId];
    const nodeToBorderWidth = parseFloat(design.forNode(toNodeId, 'borderWidth'));

    const halfNodeFromDataWidth = design.forNode(fromNodeId, 'width') / 2;
    const halfNodeFromDataHeight = design.forNode(fromNodeId, 'height') / 2;
    const halfNodeToDataWidth = design.forNode(toNodeId, 'width')/ 2;
    const halfNodeToDataHeight = design.forNode(toNodeId, 'height') / 2;

    const nodeFromCenterX = nodeFromData.position.x + halfNodeFromDataWidth + nodeFromBorderWidth;
    const nodeFromCenterY = nodeFromData.position.y + halfNodeFromDataHeight + nodeFromBorderWidth;

    const nodeToCenterX = nodeToData.position.x + halfNodeToDataWidth + nodeToBorderWidth;
    const nodeToCenterY = nodeToData.position.y + halfNodeToDataHeight + nodeToBorderWidth;

    let radianMeasure = (nodeToCenterY - nodeFromCenterY) / (nodeToCenterX - nodeFromCenterX);
    radianMeasure = Math.atan(radianMeasure);
    const angle = radianMeasure * (180 / Math.PI);

    // edge length from node center to node center
    let edgeLength = Math.sqrt(Math.pow(nodeFromCenterX - nodeToCenterX, 2) + Math.pow(nodeFromCenterY - nodeToCenterY, 2));

    // start drawing edge from border
    let moveNodeX, moveNodeY, translateX, translateY;

    // left -> right
    if (nodeFromCenterX <= nodeToCenterX) {
        moveNodeX = Math.cos(radianMeasure) * (halfNodeFromDataWidth + nodeFromBorderWidth);
        moveNodeY = Math.sin(radianMeasure) * (halfNodeFromDataHeight + nodeFromBorderWidth);
        translateX = nodeFromCenterX + moveNodeX;
        translateY = nodeFromCenterY + moveNodeY;

    // right -> left
    } else {
        moveNodeX = Math.cos(radianMeasure) * (halfNodeToDataWidth + nodeToBorderWidth);
        moveNodeY = Math.sin(radianMeasure) * (halfNodeToDataHeight + nodeToBorderWidth);
        translateX = nodeToCenterX + moveNodeX;
        translateY = nodeToCenterY + moveNodeY;
    }

    edgeLength = edgeLength - halfNodeFromDataWidth - halfNodeToDataWidth - nodeFromBorderWidth - nodeToBorderWidth;

    const data = {
        nodeFromCenterX: nodeFromCenterX,
        nodeFromCenterY: nodeFromCenterY,
        nodeToCenterX: nodeToCenterX,
        nodeToCenterY: nodeToCenterY,
        radianMeasure: radianMeasure,
        edgeLength: edgeLength,
        translateX: translateX,
        translateY: translateY,
        angle: angle
    };

    return data;
}

function calculateEdgeVisibility(edgeId, fromNodeId, toNodeId) {
    const nodeFromData = store.get().nodes[fromNodeId];
    const minLevels = [nodeFromData.visibility.minLevel];
    const maxLevels = [nodeFromData.visibility.maxLevel];

    if (toNodeId !== undefined) {
        const nodeToData = store.get().nodes[toNodeId];
        minLevels.push(nodeToData.visibility.minLevel);
        maxLevels.push(nodeToData.visibility.maxLevel);
    }

    const minLevel = Math.max(...minLevels);
    const maxLevel = Math.min(...maxLevels);

    return [minLevel, maxLevel];
}

function removeClassSelected() {
    $('edge').removeClass('selected');
}

function addClassDragging() {
    $('edge').addClass('dragging');
}

function removeClassDragging() {
    $('edge').removeClass('dragging');
}

function getHideEdgeList(currentEdgeId) {
    const edge = store.get().edges[currentEdgeId];

    // hide-on-level-X
    let hideEdgeList = '';
    for (let i = 1; i < edge.visibility.minLevel; i++) {
        hideEdgeList += 'hide-on-level-' + i + ' ';
    }
    for (let i = edge.visibility.maxLevel + 1; i <= store.get().map.visibilityLevels; i++) {
        hideEdgeList += 'hide-on-level-' + i + ' ';
    }

    return hideEdgeList;
}

function updateAllEdgesVisibilityLevel() {
    Object.keys(store.get().edges).forEach((id) => {
        // hide-on-level-X
        const currentEdge = $('edge[data-id=' + id + ']');
        const hideEdgeList = getHideEdgeList(id);
        currentEdge.removeClass().addClass(hideEdgeList);
    });
}

function updateAllEdgesMaxVisibilityLevel() {
    const newMaxVisibilityLevel = store.get().map.visibilityLevels;

    if (newMaxVisibilityLevel < oldMaxVisibilityLevel) {
        Object.values(store.get().edges).forEach((edge) => {
            edge.visibility.transact();
            if (edge.visibility.minLevel > newMaxVisibilityLevel) {
                edge.visibility.set('minLevel', newMaxVisibilityLevel);
            }
            if (edge.visibility.maxLevel > newMaxVisibilityLevel) {
                edge.visibility.set('maxLevel', newMaxVisibilityLevel);
            }
            edge.visibility.run();
        });
    } else if (newMaxVisibilityLevel > oldMaxVisibilityLevel) {
        Object.values(store.get().edges).forEach((edge) => {
            if (edge.visibility.maxLevel === oldMaxVisibilityLevel) {
                edge.visibility.set('maxLevel', newMaxVisibilityLevel);
            }
        });
    }

    oldMaxVisibilityLevel = newMaxVisibilityLevel;
}
